import { render, staticRenderFns } from "./ServiceproviderCost.vue?vue&type=template&id=142bf680&"
import script from "./ServiceproviderCost.vue?vue&type=script&lang=js&"
export * from "./ServiceproviderCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports